import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_recurring_generic_doc_queue_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  recurring_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  event_message: fromDatatype.VarcharDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  number_of_retry: fromDatatype.IntegerDatatypeInterface;
  max_retry: fromDatatype.IntegerDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  initial_planned_execute_time: fromDatatype.TimestampTzDatatypeInterface;
  event_properties: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_recurring_generic_doc_queue_RowClass
  implements bl_fi_recurring_generic_doc_queue_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  recurring_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  event_message: fromDatatype.VarcharDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  number_of_retry: fromDatatype.IntegerDatatypeInterface;
  max_retry: fromDatatype.IntegerDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  initial_planned_execute_time: fromDatatype.TimestampTzDatatypeInterface;
  event_properties: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
